/**
 * Alert Banner Component
 * 
 * Displays a prominent warning banner at the top of the page
 * showing total conflicts count and breakdown by severity.
 */

import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import { ISeverityCounts } from "../../types/conflictsDetector.types";
import styles from "../../appointmentsPage.module.css";

interface IAlertBannerProps {
  totalConflicts: number;
  severityCounts: ISeverityCounts;
  onHandleNow: () => void;
}

const AlertBanner: React.FC<IAlertBannerProps> = ({
  totalConflicts,
  severityCounts,
  onHandleNow
}) => {
  const isResolved = totalConflicts === 0;
  
  return (
    <div className={`${styles.conflictAlertBanner} ${isResolved ? styles.conflictAlertBannerResolved : ''}`}>
      <div className={`${styles.conflictAlertIcon} ${isResolved ? styles.conflictAlertIconResolved : ''}`}>
        {isResolved ? '✓' : '⚠️'}
      </div>
      <div className={styles.conflictAlertContent}>
        <div className={styles.conflictAlertTitle}>
          {isResolved 
            ? t("CONFLICTS_ALERT_RESOLVED_TITLE")
            : t("CONFLICTS_ALERT_TITLE", { count: totalConflicts })
          }
        </div>
        <div className={styles.conflictAlertDescription}>
          {isResolved
            ? t("CONFLICTS_ALERT_RESOLVED_DESC")
            : t("CONFLICTS_ALERT_DESCRIPTION", {
                critical: severityCounts.critical,
                high: severityCounts.high,
                medium: severityCounts.medium
              })
          }
        </div>
      </div>
      {!isResolved && (
        <button 
          className={styles.conflictAlertAction}
          onClick={onHandleNow}
        >
          {t("CONFLICTS_ALERT_ACTION")}
        </button>
      )}
    </div>
  );
};

export default AlertBanner;
